import { AxiosResponse } from 'axios';
import { useCoreStore } from 'src/stores/core/store';

const responeSpinnerInterceptor = (response: AxiosResponse<any>) => {
    const store = useCoreStore();

    const index = store.pendingRequests.findIndex((x) => x === `${response.config.baseURL}${response.config.url}`);
    if (index > -1) store.pendingRequests.splice(index, 1);

    return response;
}

export default responeSpinnerInterceptor;
